import React, { useEffect, useState } from "react";
import NewBtn from "../../components/Drop/NewBtn.jsx";
import { GoArrowRight } from "react-icons/go";
import YourItems from "../../components/Drop/YourItems.jsx";
import Header from "../../components/Header/index.jsx";
import SmartIcon from "../../components/ui/SmartIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCategories,
  fetchProducts,
  setSelectedCategoryIndex,
  setSelectedSubcategoryId,
  setDescription,
  setSelectedShop,
  setDeliverySlot,
  setBags,
  setDeliveryDate,
  setPickupDate,
  setPickupSlot,
  setPickUp,
  setDeliver,
  setPickUpType,
  setDeliverType,
} from "../../store/slices/cartSlice.jsx";
import { loadProductLayout, selectEditing } from "../../store/slices/layoutSlice";
import ProductGrid from "./productLayout/ProductGrid.jsx";
import { useNavigate } from "react-router-dom";
import Loader from "react-loader-spinner";
import ApiServiceHelper from "../../auth/apiServiceHelper.js";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import { WR } from "../../components/ui/tokens";

const Home = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    categoryItems,
    selectedCategoryIndex,
    selectedSubcategoryId,
    selectedItems,
    products,
    catalogueEmpty,
  } = useSelector((state) => state.cart);

  const discription = useSelector((state) => state.cart.userInfo.description);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const shopId = useSelector(state => state.cart.userInfo.shopId);
  const layoutEditing = !!useSelector(selectEditing);
  const selectedShop = useSelector(state => state.cart.userInfo.shopName);
  const currentDate = new Date();
  const year = currentDate.getUTCFullYear();
  const month = ('0' + (currentDate.getUTCMonth() + 1)).slice(-2);
  const day = ('0' + currentDate.getUTCDate()).slice(-2);
  const formattedDate = `${year}-${month}-${day}`;
  const [pickupDate, setPickupDateState] = useState(formattedDate);
  const [deliveryDate, setDeliveryDateState] = useState(dayjs(pickupDate).add(7, 'day').format('YYYY-MM-DD'));
  const [pickupSlotData, setPickupSlotData] = useState([]);
  const [checkFirstLoad, setCheckFirstLoad ] = useState(true)
  const [hoveredCat, setHoveredCat] = useState(null);

  const create_new_user_btn_arrow = {
    width: "100%",
    minHeight: "56px",
    background:
      selectedItems?.length > 0 ? WR.color.brand : "rgba(61, 69, 134, 0.2)",
    color: selectedItems?.length > 0 ? "#fff" : "rgba(0, 0, 0, 1)",
    border: "0",
    borderRadius: 999,
    boxShadow: selectedItems?.length > 0 ? WR.shadow.cta : "none",
    fontFamily: WR.font.sans,
  };

  const style_arrow = {
    marginRight: "10px",
  };

  const lang = localStorage.getItem("lang");

  // Page-load flag only. This used to live at the top of the big mount effect
  // below and RETURNED EARLY when the document was still loading — which is the
  // normal state when React mounts on a reload — silently skipping every
  // dispatch that followed it (catalogue fetch, dates, slots, pickup type).
  useEffect(() => {
    const handlePageLoad = () => setIsPageLoading(false);
    if (document.readyState === "complete") {
      handlePageLoad();
      return undefined;
    }
    window.addEventListener("load", handlePageLoad);
    return () => window.removeEventListener("load", handlePageLoad);
  }, []);

  // The catalogue is per-laundry-place, so it MUST be refetched when the shop
  // changes. The old guard was `if (!categoryItems)` — categoryItems is an
  // array, and `[]` is truthy, so it never fired; combined with redux-persist
  // this meant the catalogue was fetched once in the browser's lifetime and
  // then served from localStorage forever. Switching shops (or creating a new
  // one) kept showing the previous shop's categories, with every product call
  // 404-ing underneath.
  useEffect(() => {
    if (shopId) dispatch(fetchCategories());
  }, [shopId, dispatch]);

  // Per-shop product tile order: API first, per-shop localStorage fallback.
  useEffect(() => {
    if (shopId) dispatch(loadProductLayout(shopId));
  }, [shopId, dispatch]);

  useEffect(() => {
    if(checkFirstLoad)
    {
      dispatch(setPickupDate(pickupDate));
      setCheckFirstLoad(false)
    }else{
      dispatch(setPickupDate(pickupDate));
    }
    dispatch(setPickupSlot(null));
    dispatch(setDeliverySlot(null));
    dispatch(setSelectedShop(selectedShop));
    dispatch(setPickUp(shopId))
    dispatch(setDeliver(shopId))
    dispatch(setPickUpType("Shop"))
    dispatch(setDeliverType("Shop"))
    fetchWeekSlots(pickupDate, setPickupSlotData, "Shop", shopId, "Shop", shopId);
  }, []);

  useEffect(() => {
    if (selectedSubcategoryId) dispatch(fetchProducts(selectedSubcategoryId));
  }, [selectedSubcategoryId]);

  // No `index !== selectedCategoryIndex` guard: clicking the over-category
  // that is already displayed must still land on a real subcategory. Skipping
  // the dispatch is what made the chip row unrecoverable once the selected
  // subcategory no longer belonged to the over-category on screen.
  const handleCategoryClick = (index) => {
    if (layoutEditing) return;
    dispatch(setSelectedCategoryIndex(index));
  };


  const handleSubcategoryClick = (categoryId) => {
    if (layoutEditing) return;
    dispatch(setSelectedSubcategoryId(categoryId));
  };

  const handlePickupSlotSelection = slot => {
    if (pickupDate < formattedDate) {    
      dispatch(setPickupSlot(null));
    } else {
      dispatch(setPickupSlot(slot))
    }
  };


  const fetchWeekSlots = (date, setSlotsData, pickable_type, pickable_id, deliverable_type, deliverable_id) => {
    let url = `shop/available_slots?date=${date}`;

    if (pickable_type && pickable_id) {
      url += `&collectable_type=${pickable_type}&collectable_id=${pickable_id}`;
    }

    if (!deliverable_type && !deliverable_id) {
      // If deliverable_type and deliverable_id are null, fetch slots for both pickup and delivery
      url += `&collectable_type=${pickable_type}&collectable_id=${pickable_id}`;
    } else if (deliverable_type && deliverable_id) {
      url += `&deliverable_type=${deliverable_type}&deliverable_id=${deliverable_id}`;
    }
    ApiServiceHelper.getSlots(url)
      .then(response => {
        let firstSlot = checkPickupTime(response?.data?.dates)
        const defaultDeliveryTime = response?.data?.default_delivery_time
        if (firstSlot){
          setPickupDateState(dayjs(response?.data?.first_pickup_slot?.date).format('YYYY-MM-DD'))
          dispatch(setPickupDate(dayjs(response?.data?.first_pickup_slot?.date).format('YYYY-MM-DD')));
          setSlotsData(firstSlot?.firstSlot?.slots);
          dispatch(setPickupSlot(response?.data?.first_pickup_slot?.slots[0]));
          dispatch(setDeliverySlot(response?.data?.first_delivery_slot?.slots[0]));
          setDeliveryDateState(dayjs(response?.data?.first_delivery_slot?.date).format('YYYY-MM-DD'))
          dispatch(setDeliveryDate(dayjs(response?.data?.first_delivery_slot?.date).format('YYYY-MM-DD')));
          handlePickupSlotSelection(response?.data?.first_pickup_slot?.slots[0])
          
        }
      })
      .catch(error => {
        console.log(error, 'date error');
      });
  };

  const checkPickupTime = (slotsWithDates) => {
    let result = null;
    
    slotsWithDates.some((item) => {
      const currentDate = new Date();
      const currentHours = currentDate.getHours();
      const currentMinutes = currentDate.getMinutes();
      
      const slotDate = new Date(item.date);
      const isToday = currentDate.toDateString() === slotDate.toDateString();
  
      return item.slots.some((slot) => {
        const [start, end] = slot.split('-'); // Get the start time
        const [startHour, startMinute] = start.split(':').map(Number);
        const [endHour, endMinute] = end.split(':').map(Number);
        
        if (isToday) {
          const isAfterStart = currentHours > startHour || (currentHours === startHour && currentMinutes >= startMinute);
          const isBeforeEnd = currentHours < endHour || (currentHours === endHour && currentMinutes <= endMinute);
          if (isAfterStart && isBeforeEnd) {
            result = { firstSlot: item, slot: slot };
            return true; // Found a matching slot, break out of the loop
          }
        } else {
          // For future days, just pick the first available slot
          result = { firstSlot: item, slot: slot };
          return true; // Stop checking as soon as we find a slot on the next day
        }
  
        return false; // Continue to the next slot
      });
    });
  
    return result;
  };

  useEffect(() => {
    const fetchBags = () => {
      ApiServiceHelper.getBags('shop/order_bags')
        .then(response => {
          dispatch(setBags(response.data.bags));
        })
        .catch(error => {
          console.error('Error fetching bags:', error);
        });
    };

    fetchBags();
  }, [dispatch]);

  
 


  const handleNavigate = () => {
    navigate("/checkout");
  };

  if (isPageLoading) {
    return (
      <div className="vh-100 w-full d-flex justify-content-center">
        <div className="my-auto">
          <Loader type="Oval" color="#34A6AC" height={50} width={50} />
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Header (NAV A) re-skinned separately — shared chrome */}
      <Header />
      <div style={{ background: WR.color.bg, minHeight: "100vh", fontFamily: WR.font.sans }}>
        <div className="d-flex flex_row" style={{ alignItems: "stretch" }}>
          {/* Service rail (left vertical nav) — same categories + handleCategoryClick */}
          <div
            className="hide_in_responsive"
            style={{
              flex: "none",
              width: 138,
              display: "flex",
              flexDirection: "column",
              gap: 8,
              background: WR.color.lavSel,
              padding: "18px 10px",
              position: "sticky",
              top: 0,
              alignSelf: "flex-start",
              height: "calc(100vh - 67px)",
              overflowY: "auto",
            }}
          >
            {categoryItems?.map((over_cat, index) => {
              const active = selectedCategoryIndex === index;
              return (
                <button
                  key={over_cat.id}
                  onClick={() => handleCategoryClick(index)}
                  onMouseEnter={() => setHoveredCat(index)}
                  onMouseLeave={() => setHoveredCat(null)}
                  disabled={layoutEditing}
                  style={{
                    flex: 1,
                    minHeight: 64,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 9,
                    padding: "16px 6px",
                    borderRadius: 20,
                    border: 0,
                    cursor: layoutEditing ? "not-allowed" : "pointer",
                    opacity: layoutEditing && !active ? 0.5 : 1,
                    background: active
                      ? WR.color.surface
                      : hoveredCat === index
                      ? "rgba(255,255,255,0.45)"
                      : "transparent",
                    boxShadow: active ? WR.shadow.control : "none",
                    transition: "background .15s ease",
                  }}
                >
                  <SmartIcon src={over_cat?.icon} label={over_cat?.name} size={30} />
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      lineHeight: 1.2,
                      textAlign: "center",
                      color: active ? WR.color.brand : WR.color.inkMuted,
                    }}
                  >
                    {lang === 'french' ? over_cat?.name_en : lang === 'dutch' ? over_cat?.name_nl : over_cat?.name}
                  </span>
                </button>
              );
            })}
          </div>

          {/* Main content */}
          <div className="overflowYScroll w-100" style={{ minWidth: 0, padding: "32px clamp(18px,3.5vw,48px)" }}>
            <div
              style={{
                maxWidth: 1200,
                margin: "0 auto",
                display: "grid",
                gridTemplateColumns: "minmax(0,1fr) 340px",
                gap: "0 22px",
                alignItems: "start",
              }}
            >
              {/* Subcategory chips — full-width row spanning both columns, so
                  the product grid (left) and the cart (right) below it always
                  line up at the SAME product level on every page, regardless
                  of the description length or scroll position. */}
              <div style={{ gridColumn: "1 / -1" }}>
                {categoryItems?.map((over_cat, index) => (
                  <div
                    key={over_cat.id}
                    style={{ display: selectedCategoryIndex === index ? "block" : "none" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: 6,
                        overflowX: "auto",
                        padding: 5,
                        background: WR.color.surface,
                        borderRadius: 999,
                        boxShadow: WR.shadow.card,
                        marginBottom: 18,
                      }}
                    >
                      {[...over_cat.categories]
                        .filter((category) => category.status !== "inactive")
                        .sort((a, b) => (a?.order_by || 0) - (b?.order_by || 0))
                        .map((category) => {
                          const active = selectedSubcategoryId === category?.id;
                          return (
                            <button
                              key={category.id}
                              onClick={() => handleSubcategoryClick(category.id)}
                              disabled={layoutEditing}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 7,
                                padding: "10px 16px",
                                borderRadius: 999,
                                border: 0,
                                cursor: layoutEditing ? "not-allowed" : "pointer",
                                opacity: layoutEditing && !active ? 0.5 : 1,
                                fontSize: 13,
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                                background: active ? WR.color.brand : "transparent",
                                color: active ? "#fff" : WR.color.text,
                              }}
                            >
                              <SmartIcon
                                src={active ? category?.icon : category?.dark_icon}
                                label={category?.name}
                                size={16}
                              />
                              {lang === 'french' ? category?.name_en : lang === 'dutch' ? category?.name_nl : category?.name}
                            </button>
                          );
                        })}
                    </div>
                    {/* subcategory description — full width, above the product
                        grid AND the cart, so both line up at the product level */}
                    {over_cat.categories?.map((category) => {
                      if (selectedSubcategoryId !== category.id) return null;
                      const desc = lang === 'french' ? category.description_fr : lang === 'dutch' ? category.description_nl : category.description;
                      if (!desc) return null;
                      return (
                        <p
                          key={category.id}
                          style={{ fontSize: 14, color: WR.color.inkMuted, margin: "0 0 16px", paddingLeft: 4 }}
                        >
                          {desc}
                        </p>
                      );
                    })}
                  </div>
                ))}
              </div>

              {/* centre: product grid only */}
              <div style={{ minWidth: 0 }}>
                {/* Empty catalogue: the backend hides over-categories whose
                    products are all unavailable for this laundry and answers
                    404 when none is left. That is a state, not an error. */}
                {catalogueEmpty && (!categoryItems || categoryItems.length === 0) && (
                  <div
                    role="status"
                    style={{
                      background: WR.color.surface,
                      borderRadius: WR.radius.lg,
                      boxShadow: WR.shadow.card,
                      padding: "40px 32px",
                      textAlign: "center",
                      fontFamily: WR.font.sans,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 20,
                        fontWeight: WR.weight.extra,
                        color: WR.color.textHeading,
                        marginBottom: 8,
                      }}
                    >
                      {t("CATALOGUE_EMPTY_TITLE")}
                    </div>
                    <div style={{ fontSize: 14, color: WR.color.textMuted }}>
                      {t("CATALOGUE_EMPTY_BODY")}
                    </div>
                  </div>
                )}
                {categoryItems?.map((over_cat, index) => (
                  <div
                    key={over_cat.id}
                    style={{ display: selectedCategoryIndex === index ? "block" : "none" }}
                  >
                    {/* per-subcategory content (description + products) */}
                    {over_cat.categories?.map((category) => (
                      <div
                        key={category.id}
                        style={{ display: selectedSubcategoryId === category.id ? "block" : "none" }}
                      >
                        <ProductGrid categoryId={category.id} />
                      </div>
                    ))}
                  </div>
                ))}
              </div>

              {/* cart column */}
              <div style={{ position: "sticky", top: 90, display: "flex", flexDirection: "column", gap: 14 }}>
                <YourItems data={products} />
                <textarea
                  onChange={(e) => {
                    dispatch(setDescription(e.target.value));
                  }}
                  value={discription}
                  placeholder={t("SPECIAL_COMMENT_ON_ORDER")}
                  style={{
                    width: "100%",
                    minHeight: 78,
                    borderRadius: 18,
                    border: `1.5px solid ${WR.color.border}`,
                    padding: 14,
                    fontSize: 14,
                    resize: "none",
                    outline: "none",
                    color: WR.color.encre,
                    fontFamily: WR.font.sans,
                  }}
                />
                <NewBtn
                  onClick={handleNavigate}
                  style={create_new_user_btn_arrow}
                  className="tab_btn_w_in_mobile"
                  disable={selectedItems?.length === 0 && true}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text-center w-100">
                      <p className="next_title m-0">{t("NEXT")}</p>
                    </div>
                    <GoArrowRight
                      size={35}
                      style={style_arrow}
                      color={
                        selectedItems?.length > 0 ? "#fff" : "rgba(61, 69, 134, 1)"
                      }
                    />
                  </div>
                </NewBtn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
